import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import LightTooltip from 'Components/UI/LightTooltip';
import { CLIENT_ROLE } from 'Consts/Role';

import PreviewContent from './PreviewContent';

const useStyles = makeStyles(theme => ({
  arrow: {
    color: theme.palette.common.white,
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
    minWidth: theme.dimensions.sm,
    maxWidth: theme.dimensions.lg,
    [theme.breakpoints.down('xs')]: {
      minWidth: theme.dimensions.xs,
      maxWidth: theme.dimensions.sm,
    },
  },
  popper: {
    pointerEvents: 'all',
  },
}));

function PreviewPopover({
  children,
  open,
  pollingNotifications,
  markAllPollingNotificationsRead,
  markPollingNotificationRead,
  userRole,
}) {
  const classes = useStyles();

  return (
    <LightTooltip
      arrow
      classes={classes}
      open={open}
      placement="bottom-end"
      title={
        <PreviewContent
          pollingNotifications={pollingNotifications}
          markAllPollingNotificationsRead={markAllPollingNotificationsRead}
          markPollingNotificationRead={markPollingNotificationRead}
          userRole={userRole}
        />
      }
      PopperProps={{
        disablePortal: true,
      }}
    >
      {children}
    </LightTooltip>
  );
}

PreviewPopover.defaultProps = {
  children: null,
  open: false,
  userRole: [CLIENT_ROLE],
};

PreviewPopover.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  pollingNotifications: PropTypes.array.isRequired,
  markAllPollingNotificationsRead: PropTypes.func.isRequired,
  markPollingNotificationRead: PropTypes.func.isRequired,
  userRole: PropTypes.array,
};

export default PreviewPopover;
